import React, { useState, useContext, useRef, useEffect } from 'react';
import { getToken, saveComment, CONTENT_TYPE_COMENTARIO, CONTENT_TYPE_ARTICULO, AttachmentDTO } from "../../../services/social.services";
import GlobalContext from "../../../contexts/globalContext";
import Button from '../../atoms/button/button';
import Loading from '../../atoms/loading/loading';
import UserCard from '../social-user-card/social-user-card';
import CommentsContext from "../../../contexts/commentsContext";
import { addComment } from '../../organisms/comment-section/comment-section';
import AttachmentCard from '../attachment-card/attachment-card';

// Styles //
import "./comment-reply.scss";

const CommentReply = (props) => {

   const Context = useContext(GlobalContext);
   const [currentUserData, gigyaData, comments, setComments] = useContext(CommentsContext);
   const [text, setText] = useState("");
   const [isSavingComment, setIsSavingComment] = useState(false);
   const [isReplyActive, setReplyActive] = useState(false);
   // const textAreaRef = useRef<HTMLDivElement>(null);
   const textAreaRef = useRef<HTMLTextAreaElement>(null);
   const inputFileRef = useRef<HTMLInputElement>(null);
   const [files, setFiles] = useState<File[]>([]);
   const allowedFileExtensions = [".gif", ".jpg", ".png", ".doc", ".docx", ".pdf", ".mp3", ".m4a", ".wma", ".wav", ".mp4", ".mov", ".avi", ".flv", ".wmv" ];


   const areaClickedAction = (event) => {
      setReplyActive(true);
   }

   const comentar = async () => {
      if (!Context.gigyaContext.gigyaAccount) {
         Context.gigyaContext.loginComfamaId!();
      }
      else {
         setIsSavingComment(true);
         const token = await getToken(Context?.gigyaContext?.gigyaAccount?.UID);
         const formData:FormData = new FormData();
         const commentData:any = {
            "parentContentType": props.parentContentType,
            "parentContentId": props.parentContentId == props.grandParentContentId? props.parentContentId : props.grandParentContentId,
            "commentText": text,
            "userDoc": currentUserData.userdoc,
            "userEmail": currentUserData.usermail,
            "userName": currentUserData.username,
            "userPic": currentUserData.userpic
         };
         formData.append("commentData", JSON.stringify(commentData));
         if (files.length > 0) {
            files.forEach((file) => formData.append("base64FileList", file));
         }
         const comentarioGuardado = await saveComment(token, formData);
         limpiarCajaTexto();
         if (props.parentContentType == CONTENT_TYPE_COMENTARIO && !!props.fnHide) {
            props.fnHide();
         }
         if (comentarioGuardado.data.cod == 200) {
            setFiles([]);
            let newCommentList:any[] = addComment(comentarioGuardado.data.data, comments, props.parentContentType == CONTENT_TYPE_ARTICULO ? null : (props.parentContentId == props.grandParentContentId ? props.parentContentId : props.grandParentContentId));
            setComments([...newCommentList]);
         }
         else{
            alert("Ocurrió un error al publicar el comentario");
         }
      }
   }

   const limpiarCajaTexto = () => {
      setText("");
      // textAreaRef.current!.innerHTML = "";
      textAreaRef.current!.value = "";
      setReplyActive(false);
      textAreaRef.current?.blur();
      setIsSavingComment(false);
   }

   const descartar = () => {
      limpiarCajaTexto();
      mentionUser();
      if (props.parentContentType == CONTENT_TYPE_ARTICULO) {
         setFiles([]);
      }
      if (props.parentContentType == CONTENT_TYPE_COMENTARIO && !!props.fnHide) {
         props.fnHide();
      }
   }

   const adjuntar = () => {
      inputFileRef.current!.click();
   }

   const chgFile = (e) => {
      let totalSize = 0;
      files.forEach(oFile => {
         totalSize += oFile.size;
      });
      const newFile:File = e.target.files![0];
      if (Math.round((newFile.size / 1024)) > 6144 || Math.round((totalSize / 1024)) > 6144) {
         alert("El tamaño de los adjuntos no puede exceder los 6 MB");
      }
      else if (files.length == 3) {
         alert("Solo puede adjuntar un máximo de 3 archivos");
      }
      else {
         const isWrongExt = allowedFileExtensions.filter((extension) =>  newFile.name.toLowerCase().endsWith(extension));
         if (isWrongExt.length == 0) {
            alert("Solo se permiten archivos con extensión " + allowedFileExtensions.toString().toUpperCase());
         }
         else {
            let auxFileArray = [...files];
            auxFileArray.push(newFile);
            setFiles([...auxFileArray]);
         }
      }
      
      inputFileRef.current!.value = "";
   }

   const removeAttachment = (idx) => {
      let auxFileArray = [...files];
      auxFileArray.splice(idx, 1);
      setFiles([...auxFileArray]);
   }

   useEffect(() => {
      mentionUser();
   }, []);

   useEffect(() => {
      if (files.length > 0) {
         setReplyActive(true);
      }
   }, [files]);

   const mentionUser = () => {
      if (props.parentContentType == CONTENT_TYPE_COMENTARIO) {
         const mentionedUserName = props.replyingTo == currentUserData.username ? "" : `@${props.replyingTo}`;
         if (mentionedUserName) {
            setTextAreaValue(textAreaRef.current!.value.startsWith(mentionedUserName) ? "" : mentionedUserName + " " + textAreaRef.current!.value);
         }
      }
   }

   const setTextAreaValue = (value) => {
      setText(value);
   };

   const getFileType = (filename) => {
      return filename.substring(filename.lastIndexOf('.') + 1, filename.length) || filename;
   }

   return (

      <div className={`m-reply-container ${props.isHidden}`}>

         <div className={`loading ${isSavingComment ? "" : "hidden"}`}>
            <Loading/>
         </div>

         <div className={`reply-data ${isSavingComment ? "hidden" : ""}`}>
            <div className="reply-wrapper">
               <UserCard {...currentUserData} />
               <div className="reply-box-data">
                  <div className="reply-text">
                     {/* <div className="reply-text-area"
                        contentEditable={true}
                        ref={textAreaRef}
                        onClick={areaClickedAction}>
                     </div> */}
                     <textarea className="reply-text-area"
                        ref={textAreaRef}
                        maxLength={1000}
                        value={text}
                        placeholder="Ingresa aquí tu mensaje o comentario"
                        onClick={areaClickedAction}
                        onChange={(event) => { setTextAreaValue(event.target.value); }}/>
                     <div className="attach-icon-container">
                        <div className={`attach-icon ${props.parentContentType != CONTENT_TYPE_ARTICULO ? "hidden" : ""}`}>
                           <input ref={inputFileRef} type="file" accept={allowedFileExtensions.toString()} className="input-file" onChange={e => {chgFile(e);}}/>
                           <button className="btn-attach" onClick={adjuntar}>
                              <i className="icon-paperclip" />
                           </button>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <div className="reply-attachments">
               <div className="reply-attachments_gap">
                  &nbsp;
               </div>
               <div className="reply-attachments_container">
                  {files.map((attachment, index) => (
                     <div className="reply-attachments_container__item">
                        <button type="button" className={`btn-del-item`} onClick={()=>{removeAttachment(index)}}>
                        <i className="icon-trash-alt1"/>
                        </button>
                        <AttachmentCard editMode={false}
                                       file={attachment}
                                       fileType={getFileType(attachment.name)}
                                       fileName={attachment.name}
                                       fileUrl=""
                        />
                     </div>
                  ))}
               </div>
            </div>
         </div>

         <div className={`wrapper-bottom ${!isReplyActive || isSavingComment ? "hidden" : ""}`}>
            <div className="bar-gap">
            </div>
            <div className="button-bar">
               <div className="button-bar-enviar">
                  <Button
                  type="button"
                  text="COMENTAR"
                  classname="a-button__magenta"
                  href={void(0)}
                  isDisabled={text.length < 1 || isSavingComment}
                  onClickAction={comentar}/>
               </div>
               <div className="button-bar-descartar">
                  <Button
                  type="button"
                  text="DESCARTAR"
                  classname="a-button primary"
                  href={void(0)}
                  isDisabled={isSavingComment}
                  onClickAction={descartar}/>
               </div>
            </div>
         </div>

      </div>

   );
}

 export default CommentReply;